import React from "react";
import { Hero } from '../components/Hero';

const HomePage = () => (
  <div>
    <Hero />
  </div>
);

export default HomePage;